import styled from "styled-components";

export default function NetworkInfo() {
  return (
    <Wrapper>
      <Icon></Icon>
      <Title className="merri">Annunciation Catholic Church</Title>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  padding-bottom: 0;
  gap: 12px;
`;
const Icon = styled.div`
  background: #fff;
  border-radius: 100px;
  aspect-ratio: 1;
  height: 60px;
  box-shadow: rgba(0, 0, 0, 0.4) 0 0 6px;
  background-image: url(//d6iyrqjd26xke.cloudfront.net/20181012150130/icon.jpg);
  background-size: cover;
  background-position: center center;
`;
const Title = styled.div`
  font-size: 22px;
  line-height: 1.1em;
`;
